import { useState } from "react";
import { FileSelectButton, RadioButton } from "components/UI";
import { Observer } from "mobx-react";
import translationStore from "stores/translation-store";

import styles from "./style"

export default function UploadTemplate(props)
{
  const [template, setTemplate] = useState('classic');
  const radioButtonStyle = {marginTop: 4};

  function onSelectFiles(files) {
    props.onComplete({template, files});
  }

  return (
    <Observer>
    {
      () => (
        <>
          <div className="title">{translationStore.translate("myalbums.add.choose-template.title")}</div>
          <div className="subtitle">{translationStore.translate("myalbums.add.choose-template.description")}</div>

          <div className="options">
            <div className="option">
              <RadioButton
                buttonStyle={radioButtonStyle}
                selected={template === "classic"}
                onSelect={() => setTemplate("classic")}
              >
                <div className="option-title">{translationStore.translate("templates.classic.title")}</div>
                <div className="text">{translationStore.translate("templates.classic.description")}</div>
              </RadioButton>
            </div>

            <div className="option">
              <RadioButton
                buttonStyle={radioButtonStyle}
                selected={template === "enriched"}
                onSelect={() => setTemplate("enriched")}
              >
                <div className="option-title">{translationStore.translate("templates.enriched.title")}</div>
                <div className="text">{translationStore.translate("templates.enriched.description")}</div>
              </RadioButton>
            </div>
          </div>

          <FileSelectButton
            className="accent large"
            enabled={true}
            onSelect={onSelectFiles}
            multiple
          >
            {translationStore.translate("myalbums.add.button")}
          </FileSelectButton>

          <style jsx>{styles}</style>
          <style jsx>
          {`
            .options {
              margin-bottom: 5rem;
              margin-top: 3rem;
              display: flex;
              flex-direction: column;
              flex: 1;
              flex-wrap: wrap;
            }

            .options .option {
              flex: 1;
              margin-top: 3rem;
              max-width: 40rem;
            }

            .options .option-title {
              font-size: 2rem;
              font-weight: 300;
            }

            .options .option-title>span {
              color: #7f7f7f;
            }

            .options .text {
              text-align: left;
            }
          `}
          </style>
        </>
      )
    }
    </Observer>
  )
}